import { format, isValid, parseISO } from "date-fns";

export function formatDate(value: string | null | undefined, pattern: string) {
  if (!value) return null;

  const date = parseISO(value);
  return isValid(date) ? format(date, pattern) : null;
}
